export class Lot {

	public numLot: string;

	public dateLivraison: string;

	public description: string;

	public dateExecution: string;

	public quantite: string;

	constructor() {
		this.numLot = '';
		this.dateLivraison = '';
		this.description = '';
		this.dateExecution = '';
		this.quantite = '';

	}
}
